import React from "react"

import { Link as PrismicLink } from "prismic-reactjs"

import {
  StyledLink,
  StyledLinkProps,
  StyledGatsbyLink,
  StyledGatsbyLinkProps,
} from "./StyledLink"

interface OwnProps {
  url: Parameters<typeof PrismicLink.url>[0] | PrismicLink["link_type"] | string
}

export type LinkProps = OwnProps &
  Omit<StyledLinkProps, "href"> &
  Omit<StyledGatsbyLinkProps, "to">

export const Link: React.FC<LinkProps> = ({
  url,
  ...styledLinkProps
}): React.ReactElement => {
  if (typeof(url) === "string") {
    return <StyledLink href={url} {...styledLinkProps} />
  } else if (url.link_type === "Web") {
    return <StyledLink href={url.url} {...styledLinkProps} />
  } else {
    return <StyledGatsbyLink to={PrismicLink.url(url)} {...styledLinkProps} />
  }
}
